<template>
    <div class="dashboard-container">
        <div class="row">
            <div class="col-lg-12">
                <div class="page-header">
                    <h1>Portal Emulzint - Dashboard</h1>
                    <p class="text-muted">Visão geral das estatísticas de uso da plataforma</p>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div v-if="loading" class="text-center">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
            <p>Carregando estatísticas...</p>
        </div>

        <!-- Error State -->
        <div v-if="error" class="alert alert-danger">
            <i class="fa fa-exclamation-triangle"></i>
            {{ error }}
        </div>

        <!-- Dashboard Content -->
        <div v-if="!loading && !error && statistics">
            <!-- Total Statistics Cards -->
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="card stats-card hits-card">
                        <div class="card-body">
                            <div class="stat-icon">
                                <i class="fa fa-eye"></i>
                            </div>
                            <div class="stat-content">
                                <h3>{{ statistics.totals.hits | number }}</h3>
                                <p>Total de Visualizações</p>
                                <small class="text-success">
                                    <i class="fa fa-arrow-up"></i>
                                    {{ statistics.recent.totals.hits }} nos últimos 30 dias
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="card stats-card shares-card">
                        <div class="card-body">
                            <div class="stat-icon">
                                <i class="fa fa-share-alt"></i>
                            </div>
                            <div class="stat-content">
                                <h3>{{ statistics.totals.shares | number }}</h3>
                                <p>Total de Compartilhamentos</p>
                                <small class="text-success">
                                    <i class="fa fa-arrow-up"></i>
                                    {{ statistics.recent.totals.shares }} nos últimos 30 dias
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="card stats-card downloads-card">
                        <div class="card-body">
                            <div class="stat-icon">
                                <i class="fa fa-download"></i>
                            </div>
                            <div class="stat-content">
                                <h3>{{ statistics.totals.downloads | number }}</h3>
                                <p>Total de Downloads</p>
                                <small class="text-success">
                                    <i class="fa fa-arrow-up"></i>
                                    {{ statistics.recent.totals.downloads }} nos últimos 30 dias
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="card stats-card total-card">
                        <div class="card-body">
                            <div class="stat-icon">
                                <i class="fa fa-chart-line"></i>
                            </div>
                            <div class="stat-content">
                                <h3>{{ (statistics.totals.hits + statistics.totals.shares + statistics.totals.downloads) | number }}</h3>
                                <p>Total de Interações</p>
                                <small class="text-info">
                                    <i class="fa fa-info-circle"></i>
                                    Soma de todas as ações
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Category Statistics -->
            <div class="row">
                <div class="col-lg-4">
                    <div class="card category-card">
                        <div class="card-header">
                            <h4><i class="fa fa-book"></i> Receitas</h4>
                        </div>
                        <div class="card-body">
                            <div class="stat-row">
                                <span class="stat-label">Visualizações:</span>
                                <span class="stat-value">{{ statistics.recipes.hits | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Compartilhamentos:</span>
                                <span class="stat-value">{{ statistics.recipes.shares | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Downloads:</span>
                                <span class="stat-value">{{ statistics.recipes.downloads | number }}</span>
                            </div>
                            <hr>
                            <div class="recent-stats">
                                <h6>Últimos 30 dias:</h6>
                                <div class="stat-row">
                                    <span class="stat-label">Visualizações:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.recipes.hits | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Compartilhamentos:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.recipes.shares | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Downloads:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.recipes.downloads | number }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="card category-card">
                        <div class="card-header">
                            <h4><i class="fa fa-file-text"></i> Materiais</h4>
                        </div>
                        <div class="card-body">
                            <div class="stat-row">
                                <span class="stat-label">Visualizações:</span>
                                <span class="stat-value">{{ statistics.materials.hits | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Compartilhamentos:</span>
                                <span class="stat-value">{{ statistics.materials.shares | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Downloads:</span>
                                <span class="stat-value">{{ statistics.materials.downloads | number }}</span>
                            </div>
                            <hr>
                            <div class="recent-stats">
                                <h6>Últimos 30 dias:</h6>
                                <div class="stat-row">
                                    <span class="stat-label">Visualizações:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.materials.hits | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Compartilhamentos:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.materials.shares | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Downloads:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.materials.downloads | number }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="card category-card">
                        <div class="card-header">
                            <h4><i class="fa fa-cube"></i> Produtos</h4>
                        </div>
                        <div class="card-body">
                            <div class="stat-row">
                                <span class="stat-label">Visualizações:</span>
                                <span class="stat-value">{{ statistics.products.hits | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Compartilhamentos:</span>
                                <span class="stat-value">{{ statistics.products.shares | number }}</span>
                            </div>
                            <div class="stat-row">
                                <span class="stat-label">Downloads:</span>
                                <span class="stat-value">{{ statistics.products.downloads | number }}</span>
                            </div>
                            <hr>
                            <div class="recent-stats">
                                <h6>Últimos 30 dias:</h6>
                                <div class="stat-row">
                                    <span class="stat-label">Visualizações:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.products.hits | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Compartilhamentos:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.products.shares | number }}</span>
                                </div>
                                <div class="stat-row">
                                    <span class="stat-label">Downloads:</span>
                                    <span class="stat-value text-success">{{ statistics.recent.products.downloads | number }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Charts Section -->
            <div class="row">
                <div class="col-lg-8">
                    <div class="card chart-card">
                        <div class="card-header">
                            <h4><i class="fa fa-line-chart"></i> Atividade dos Últimos 7 Dias</h4>
                        </div>
                        <div class="card-body">
                            <canvas ref="lineChart" height="100"></canvas>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4">
                    <div class="card chart-card">
                        <div class="card-header">
                            <h4><i class="fa fa-pie-chart"></i> Distribuição por Categoria</h4>
                        </div>
                        <div class="card-body">
                            <canvas ref="pieChart" height="200"></canvas>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Additional Charts -->
            <div class="row">
                <div class="col-lg-6">
                    <div class="card chart-card">
                        <div class="card-header">
                            <h4><i class="fa fa-bar-chart"></i> Comparação de Ações</h4>
                        </div>
                        <div class="card-body">
                            <canvas ref="barChart" height="150"></canvas>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6">
                    <div class="card chart-card">
                        <div class="card-header">
                            <h4><i class="fa fa-area-chart"></i> Tendência de Visualizações</h4>
                        </div>
                        <div class="card-body">
                            <canvas ref="areaChart" height="150"></canvas>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Refresh Button -->
            <div class="row">
                <div class="col-lg-12 text-center">
                    <button @click="loadStatistics" class="btn btn-primary" :disabled="loading">
                        <i class="fa fa-refresh" :class="{ 'fa-spin': loading }"></i>
                        Atualizar Estatísticas
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js'

    export default {
        data() {
        return {
            loading: false,
            error: null,
            statistics: null,
            charts: {
                lineChart: null,
                pieChart: null,
                barChart: null,
                areaChart: null
            }
        }
    },
    mounted() {
        this.loadStatistics();
    },
    beforeDestroy() {
        // Destroy charts to prevent memory leaks
        Object.values(this.charts).forEach(chart => {
            if (chart) {
                chart.destroy();
            }
        });
    },
    methods: {
        async loadStatistics() {
            this.loading = true;
            this.error = null;
            
            try {
                const response = await this.$http.get(`${this.$store.getters.api}dashboard/statistics`);
                
                if (response.data.success) {
                    this.statistics = response.data.data;
                    this.$nextTick(() => {
                        this.createCharts();
                    });
                } else {
                    this.error = 'Erro ao carregar estatísticas';
                }
            } catch (error) {
                console.error('Erro ao carregar estatísticas:', error);
                this.error = 'Erro ao conectar com o servidor';
            } finally {
                this.loading = false;
            }
        },
        
        createCharts() {
            if (!this.statistics || !this.statistics.historical) return;
            
            // Wait a bit more to ensure DOM is ready
            setTimeout(() => {
                this.createLineChart();
                this.createPieChart();
                this.createBarChart();
                this.createAreaChart();
            }, 100);
        },
        
        createLineChart() {
            if (!this.$refs.lineChart) return;
            
            const ctx = this.$refs.lineChart.getContext('2d');
            
            // Destroy existing chart
            if (this.charts.lineChart) {
                this.charts.lineChart.destroy();
            }
            
            const labels = this.statistics.historical.map(item => item.label);
            const hitsData = this.statistics.historical.map(item => item.totals.hits);
            const sharesData = this.statistics.historical.map(item => item.totals.shares);
            const downloadsData = this.statistics.historical.map(item => item.totals.downloads);
            
            this.charts.lineChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Visualizações',
                            data: hitsData,
                            borderColor: '#667eea',
                            backgroundColor: 'rgba(102, 126, 234, 0.1)',
                            tension: 0.4,
                            fill: false
                        },
                        {
                            label: 'Compartilhamentos',
                            data: sharesData,
                            borderColor: '#f093fb',
                            backgroundColor: 'rgba(240, 147, 251, 0.1)',
                            tension: 0.4,
                            fill: false
                        },
                        {
                            label: 'Downloads',
                            data: downloadsData,
                            borderColor: '#4facfe',
                            backgroundColor: 'rgba(79, 172, 254, 0.1)',
                            tension: 0.4,
                            fill: false
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'top',
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }]
                    }
                }
            });
        },
        
        createPieChart() {
            if (!this.$refs.pieChart) return;
            
            const ctx = this.$refs.pieChart.getContext('2d');
            
            if (this.charts.pieChart) {
                this.charts.pieChart.destroy();
            }
            
            this.charts.pieChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: ['Receitas', 'Materiais', 'Produtos'],
                    datasets: [{
                        data: [
                            this.statistics.recipes.hits + this.statistics.recipes.shares + this.statistics.recipes.downloads,
                            this.statistics.materials.hits + this.statistics.materials.shares + this.statistics.materials.downloads,
                            this.statistics.products.hits + this.statistics.products.shares + this.statistics.products.downloads
                        ],
                        backgroundColor: [
                            '#667eea',
                            '#f093fb',
                            '#4facfe'
                        ],
                        borderWidth: 2,
                        borderColor: '#fff'
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'bottom',
                    }
                }
            });
        },
        
        createBarChart() {
            if (!this.$refs.barChart) return;
            
            const ctx = this.$refs.barChart.getContext('2d');
            
            if (this.charts.barChart) {
                this.charts.barChart.destroy();
            }
            
            this.charts.barChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Visualizações', 'Compartilhamentos', 'Downloads'],
                    datasets: [
                        {
                            label: 'Receitas',
                            data: [this.statistics.recipes.hits, this.statistics.recipes.shares, this.statistics.recipes.downloads],
                            backgroundColor: 'rgba(102, 126, 234, 0.8)',
                            borderColor: '#667eea',
                            borderWidth: 1
                        },
                        {
                            label: 'Materiais',
                            data: [this.statistics.materials.hits, this.statistics.materials.shares, this.statistics.materials.downloads],
                            backgroundColor: 'rgba(240, 147, 251, 0.8)',
                            borderColor: '#f093fb',
                            borderWidth: 1
                        },
                        {
                            label: 'Produtos',
                            data: [this.statistics.products.hits, this.statistics.products.shares, this.statistics.products.downloads],
                            backgroundColor: 'rgba(79, 172, 254, 0.8)',
                            borderColor: '#4facfe',
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'top',
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }]
                    }
                }
            });
        },
        
        createAreaChart() {
            if (!this.$refs.areaChart) return;
            
            const ctx = this.$refs.areaChart.getContext('2d');
            
            if (this.charts.areaChart) {
                this.charts.areaChart.destroy();
            }
            
            const labels = this.statistics.historical.map(item => item.label);
            const hitsData = this.statistics.historical.map(item => item.totals.hits);
            
            this.charts.areaChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Total de Visualizações',
                        data: hitsData,
                        borderColor: '#43e97b',
                        backgroundColor: 'rgba(67, 233, 123, 0.3)',
                        tension: 0.4,
                        fill: true
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'top',
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                color: 'rgba(0,0,0,0.1)'
                            }
                        }]
                    }
                }
            });
        }
    },
    filters: {
        number(value) {
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        }
    }
</script>

<style scoped>
.dashboard-container {
    padding: 20px;
    background-color: #f8f9fa;
    min-height: 100vh;
}

.page-header {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e9ecef;
}

.page-header h1 {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 10px;
}

/* Stats Cards */
.stats-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-bottom: 20px;
            overflow: hidden;
        }

.stats-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

.stats-card .card-body {
    padding: 25px;
    display: flex;
    align-items: center;
    position: relative;
}

.stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    font-size: 24px;
    color: white;
}

.stat-content h3 {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0;
    color: #2c3e50;
}

.stat-content p {
    margin: 5px 0;
    color: #6c757d;
    font-weight: 500;
}

.stat-content small {
    font-size: 0.85rem;
    font-weight: 500;
}

/* Card Colors */
.hits-card .stat-icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.shares-card .stat-icon {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.downloads-card .stat-icon {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.total-card .stat-icon {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

/* Category Cards */
.category-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-bottom: 20px;
}

.category-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

.category-card .card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px 12px 0 0;
    padding: 15px 20px;
}

.category-card .card-header h4 {
    margin: 0;
    font-weight: 600;
    font-size: 1.2rem;
}

.category-card .card-header i {
    margin-right: 10px;
}

.category-card .card-body {
    padding: 20px;
}

.stat-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 0;
}

.stat-label {
    color: #6c757d;
    font-weight: 500;
}

.stat-value {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
}

.recent-stats {
    margin-top: 15px;
}

.recent-stats h6 {
    color: #495057;
    font-weight: 600;
    margin-bottom: 10px;
}

/* Loading and Error States */
.text-center {
    padding: 40px 20px;
}

.text-center i {
    color: #667eea;
    margin-bottom: 15px;
}

.alert {
    border-radius: 8px;
    border: none;
    margin-bottom: 20px;
}

.alert i {
    margin-right: 8px;
}

/* Button Styles */
.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 8px;
    padding: 12px 30px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
    opacity: 0.6;
    transform: none;
    box-shadow: none;
}

/* Responsive Design */
@media (max-width: 768px) {
    .dashboard-container {
        padding: 15px;
    }
    
    .stats-card .card-body {
        flex-direction: column;
        text-align: center;
        padding: 20px;
    }
    
    .stat-icon {
        margin-right: 0;
        margin-bottom: 15px;
    }
    
    .stat-content h3 {
        font-size: 2rem;
    }
    
    .category-card .card-body {
        padding: 15px;
    }
    
    .stat-row {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 8px;
    }
    
    .stat-value {
        margin-top: 5px;
        font-size: 1rem;
    }
}

@media (max-width: 576px) {
    .page-header h1 {
        font-size: 1.8rem;
    }
    
    .stat-content h3 {
        font-size: 1.8rem;
    }
    
    .stat-icon {
        width: 50px;
        height: 50px;
        font-size: 20px;
    }
}

/* Chart Cards */
.chart-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin-bottom: 20px;
    overflow: hidden;
}

.chart-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
}

.chart-card .card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px 12px 0 0;
    padding: 15px 20px;
}

.chart-card .card-header h4 {
    margin: 0;
    font-weight: 600;
    font-size: 1.2rem;
}

.chart-card .card-header i {
    margin-right: 10px;
}

.chart-card .card-body {
    padding: 20px;
    position: relative;
}

.chart-card canvas {
    max-height: 300px;
}

/* Animation for loading */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.stats-card,
.category-card,
.chart-card {
    animation: fadeIn 0.6s ease-out;
}

.stats-card:nth-child(1) { animation-delay: 0.1s; }
.stats-card:nth-child(2) { animation-delay: 0.2s; }
.stats-card:nth-child(3) { animation-delay: 0.3s; }
.stats-card:nth-child(4) { animation-delay: 0.4s; }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue